module.exports = __webpack_public_path__ + "static/img/logo.efc8ad79.svg";